import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useMemo, useRef } from 'react';
import { motion } from 'motion/react';

import confetti from '../../assets/video/confetti.webm';

export const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
}) => {
  const confettiRef = useRef(null);

  const isWinner = useMemo(() => currentState === 'S4', [currentState]);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current && isWinner) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, 1000);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, [isWinner]);

  const defaultDelay = 1;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={styles['wrapper']}
    >
      <div className={styles.wrapperTitleBlock}>
        {isWinner && (
          <>
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: [0, 1, 0, 1, 0, 1] }}
              transition={{
                scale: { duration: 1, delay: defaultDelay },
                opacity: {
                  duration: 3,
                  delay: defaultDelay + 0.8,
                  times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                },
              }}
              className={styles.titleBlock}
            >
              <motion.div
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: [0, 1, 0, 1, 0, 1] }}
                transition={{
                  scale: { duration: 1, delay: defaultDelay + 0.5 },
                  opacity: {
                    duration: 3,
                    delay: defaultDelay + 0.5,
                    times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                  },
                }}
                className={styles.bgWinner}
              />

              <div className={styles.leftTop} />
              <div className={styles.rightTop} />
              <div className={styles.rightBottom} />
              <div className={styles.leftBottom} />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: [0, 1, 0, 1, 0, 1], scale: 1 }}
              transition={{
                scale: { duration: 1, delay: defaultDelay + 0.5 },
                opacity: {
                  duration: 3,
                  delay: defaultDelay + 0.5,
                  times: [0, 0.2, 0.4, 0.6, 0.8, 1],
                },
              }}
              className={styles.winner}
            >
              ПОБЕДИТЕЛЬ!
            </motion.div>
          </>
        )}
      </div>

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speed}
                classNames="position"
              >
                <Message
                  winId={winId}
                  key={item.id}
                  message={item.message}
                  titrTag={item.titrTag}
                  authorFontSize={authorFontSize}
                  currentState={currentState}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>

      {isWinner && (
        <video
          ref={confettiRef}
          muted="muted"
          loop
          playsInline
          className={styles.confetti}
        >
          <source src={confetti} type="video/webm"></source>
        </video>
      )}
    </motion.div>
  );
};
